const CHARACTER_LIMITS = {
  45: 45,
  60: 60,
  100: 100,
  200: 200,
  250: 250,
  300: 300,
  500: 500,
  2000: 2000,
};

// commented out keys currently has no limit

// unix timestamp December 31 9999 23:59:59
const DATE_LIMIT = 253402271999;

export const CE_LIMITS = {
  ce_unique_id: CHARACTER_LIMITS['45'],
  ce_name: CHARACTER_LIMITS['300'],
  ce_trading_name: CHARACTER_LIMITS['500'],
  ce_en_name: CHARACTER_LIMITS['200'],
  // ce_confidential,
  br_street: CHARACTER_LIMITS['500'],
  br_city: CHARACTER_LIMITS['100'],
  br_state: CHARACTER_LIMITS['100'],
  br_post_code: CHARACTER_LIMITS['250'],
  // br_country,
  br_full_address: CHARACTER_LIMITS['500'],
  // ce_website,
  // tax_id,
  // vat,
  // company_id_number,
  // business_reg_number,
  // duns_number,
};

export const CERT_LIMITS = {
  cert_unique_id: CHARACTER_LIMITS['60'],
  cert_number: CHARACTER_LIMITS['60'],
  cert_status: CHARACTER_LIMITS['45'],
  cert_type: CHARACTER_LIMITS['45'],
  cert_scope: CHARACTER_LIMITS['2000'],
  flexible_scope: CHARACTER_LIMITS['2000'],
  cert_orig_issue_date: DATE_LIMIT,
  cert_issue_date: DATE_LIMIT,
  cert_expiry_date: DATE_LIMIT,
  ce_unique_id: CHARACTER_LIMITS['45'],
  main_site_street: CHARACTER_LIMITS['500'],
  main_site_city: CHARACTER_LIMITS['100'],
  main_site_state: CHARACTER_LIMITS['100'],
  main_site_post_code: CHARACTER_LIMITS['250'],
  // main_site_country,
  main_site_full_address: CHARACTER_LIMITS['500'],
  // cb_identity_number,
  // cb_name,
  // cb_acronym,
  // ab_name,
  // ab_acronym,
};

export const SITE_LIMITS = {
  cert_identity_number: CHARACTER_LIMITS['60'],
  cert_unique_id: CHARACTER_LIMITS['45'],
  // type,
  street: CHARACTER_LIMITS['500'],
  city: CHARACTER_LIMITS['100'],
  state: CHARACTER_LIMITS['100'],
  post_code: CHARACTER_LIMITS['250'],
  // countries_id,
  full_address: CHARACTER_LIMITS['500'],
  scope: CHARACTER_LIMITS['2000'],
};

export const HELMET_DESC_LIMIT = CHARACTER_LIMITS[250];
